import { transition } from '@helpers/animate';
import brand from '@helpers/brand';
import { fluid } from '@helpers/fluid';
import fonts from '@helpers/fonts';
import { Device, until } from '@helpers/media';
import scrollbars from '@helpers/scrollbars';
import { paragraphSmall, paragraphTiny } from '@helpers/typography';
import styled from 'styled-components';
const Container = styled.div `
  padding-bottom: 15px;
`;
const List = styled.ul `
  ${scrollbars};

  overflow: auto;
  white-space: nowrap;
`;
const Item = styled.li `
  ${transition('color')};
  ${paragraphSmall};

  line-height: ${fluid(30, 30)};
  display: inline-block;
  margin: 0 4px 0 0;
  color: ${brand.orange};

  &:hover,
  &:focus-within {
    color: ${brand.grey.grey41};
  }

  &::after {
    content: '>';
    margin-left: 4px;
    color: ${brand.orange};
  }

  &:first-child {
    @media ${until(Device.Tablet)} {
      display: none;
    }
  }

  &:last-child {
    color: ${brand.grey.grey41};

    &::after {
      display: none;
    }
  }
`;
const ItemLink = styled.a `
  ${transition('text-decoration-color')};
  ${paragraphTiny};

  text-decoration: underline;
  text-decoration-color: currentColor;
  text-underline-offset: 2px;

  &:not([aria-current='location']).focus-ring,
  &:not([aria-current='location']):hover {
    text-decoration-color: currentColor;
  }

  ${Item}:last-child & {
    text-decoration: none;
  }

  &[aria-current='location'] {
    ${fonts.agBook.regular};
  }
`;
const BreadcrumbStyles = {
    Container,
    List,
    Item,
    ItemLink,
};
export default BreadcrumbStyles;
